import RequisitesTableData from "./RequisitesTableData";

export default RequisitesTableData;